import { useState, useEffect } from "react";
import FormInput from "../../../components/controls/FormInput";
import FormTextArea from "../../../components/controls/FormTextArea";
import { createPermission, updatePermission } from "../../../db/PermissionsApi";

export default function PermissionModal({
  isOpen,
  onClose,
  onSave,
  permissionItem,
  userId,
}) {
  if (!isOpen) return null;

  const isEditing = !!permissionItem;

  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (isEditing) {
      setCode(permissionItem.code || "");
      setName(permissionItem.name || "");
      setDescription(permissionItem.description || "");
    } else {
      setCode("");
      setName("");
      setDescription("");
    }
  }, [isEditing, permissionItem]);

  const handleSave = async () => {
    if (!name.trim()) return alert("Le nom est obligatoire.");
    if (!isEditing && !code.trim())
      return alert("Le code est obligatoire pour une nouvelle permission.");

    if (!userId) return alert("Utilisateur non connecté.");

    if (isEditing) {
      await updatePermission(userId, permissionItem.id, {
        name,
        description,
      });
    } else {
      await createPermission(userId, {
        code,
        name,
        description,
      });
    }

    onSave();
    onClose();
  };

  return (
    <dialog className="modal modal-open modal-middle">
      <div className="modal-box max-w-xl">
        <h3 className="font-bold text-lg mb-4">
          {isEditing ? "Modifier une permission" : "Ajouter une permission"}
        </h3>

        {!isEditing && (
          <FormInput
            label="Code (section.onglet.action)"
            name="code"
            placeholder={"section.onglet.action"}
            value={code}
            onChange={(n, v) => setCode(v)}
            required
          />
        )}

        <FormInput
          label="Nom"
          name="name"
          value={name}
          onChange={(n, v) => setName(v)}
          required
        />

        <FormTextArea
          label="Description"
          name="description"
          value={description}
          onChange={(n, v) => setDescription(v)}
          lines={4}
        />

        <div className="modal-action mt-6">
          <button className="btn btn-outline rounded-full" onClick={onClose}>
            Annuler
          </button>
          <button
            className="btn bg-primary text-white rounded-full"
            onClick={handleSave}
          >
            Enregistrer
          </button>
        </div>
      </div>

      {/* Backdrop cliquable */}
      <form method="dialog" className="modal-backdrop" onClick={onClose}>
        <button>close</button>
      </form>
    </dialog>
  );
}
